var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgFormTopNavyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 93,
    viewBox: "0 0 1440 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.2395 13.522C55.0373 25.118 31.7209 38.7767 13 67.5C6.89661 76.8644 0 93 0 93L1440 93.0003C1440 93.0003 1429.6 66.6503 1389.02 59.3918L187.205 1.21284C157.831 -2.32799 109.459 1.91673 82.2395 13.522Z",
    fill: "#021F2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFormTopNavyDark);
export default __webpack_public_path__ + "static/media/bg-form-top-navy-dark.ab41772687d6f154a0da3e998532e488.svg";
export { ForwardRef as ReactComponent };